import _ from 'underscore';
import {i18n} from '@netx/core-next/locales/i18n-instance';

export const ids = {
	text: 1,
	textarea: 2,
	select: 3, // these often have spec1 = 4
	date: 4,
	multiselect: 5,
	number: 7,
	hierarchical: 8, // Stupid terrible beast
	semantic: 12,
	tag: 13,
};

export let defaultAttributeColumns = [
	{code: 'name', name: i18n.t('i18n.name')},
	{code: 'filetypelabel', name: i18n.t('i18n.fileType')},
	{code: null, name: i18n.t('i18n.fileInfo')},
	{code: 'fileSize2', name: i18n.t('i18n.fileSize')},
	{code: 'creationdate', name: i18n.t('i18n.creationDate')},
	{code: null, name: i18n.t('i18n.status')},
];

export const systemAttributes = [
	{code: 'name', key: 'name', id: -100, name: i18n.t('i18n.name')},
	{code: 'file', key: 'file', id: -101, name: i18n.t('i18n.file')},
	{code: 'assetId', key: 'assetId', id: -102, name: i18n.t('i18n.assetId')},
	{
		code: 'fileSize2',
		key: 'fileSize2',
		id: -104,
		name: i18n.t('i18n.fileSize'),
	},
	{
		code: 'filetypelabel',
		key: 'filetypelabel',
		id: -105,
		name: i18n.t('i18n.fileType'),
	},
	{
		code: 'fileFormatFamily',
		key: 'fileFormatFamily',
		id: -106,
		name: i18n.t('i18n.fileFormatFamily'),
	},
	{
		code: 'categoryPaths',
		key: 'folderPath',
		id: -108,
		name: i18n.t('i18n.folderPath'),
	},
	{code: 'moddate', key: 'moddate', id: -110, name: i18n.t('i18n.modDate')},
	{
		code: 'creationdate',
		key: 'creationdate',
		id: -111,
		name: i18n.t('i18n.creationDate'),
	},
	{
		code: 'importDate',
		key: 'importDate',
		id: -112,
		name: i18n.t('i18n.importDate'),
	},
	{
		code: 'smart labels',
		key: 'smart labels',
		id: -119,
		name: i18n.t('i18n.smartLabels'),
	},
];

// !!! hierarchical is not supported for edit !!!
// !!! I REPEAT: hierarchical is not editable !!!
export let editable = [
	1, // text
	2, // textarea
	3, // select
	4, // date
	7, // number
	12, // semantic
	13, // tag
];

// Attribute types that are allowed to be facets
export let facetAttributeSupport = [
	3, // Select
	13, // Tag
];

// Attribute types that use vocabularies
export let vocabularyAttributes = [
	3, // Select
	13, // Tag
];

export let numberTypes = [
	{
		key: 'whole',
		name: i18n.t('i18n.wholeNumber'),
		validator: '^-?\\d+$',
		warning: i18n.t('i18n.wholeNumberWarning'),
	},
	{
		key: 'oneDecimal',
		name: i18n.t('i18n.oneDecimal'),
		validator: '^(-?\\d+(\\.\\d{0,1})?|-?\\.\\d{1})$',
		warning: i18n.t('i18n.oneDecimalWarning'),
		maxDecimal: 1,
	},
	{
		key: 'twoDecimals',
		name: i18n.t('i18n.twoDecimals'),
		validator: '^(-?\\d+(\\.\\d{0,2})?|-?\\.\\d{1,2})$',
		warning: i18n.t('i18n.twoDecimalsWarning'),
		maxDecimal: 2,
	},
	{
		key: 'threeDecimals',
		name: i18n.t('i18n.threeDecimals'),
		validator: '^(-?\\d+(\\.\\d{0,3})?|-?\\.\\d{1,3})$',
		warning: i18n.t('i18n.threeDecimalsWarning'),
		maxDecimal: 3,
	},
	{
		// "free," but not negative
		key: 'unlimited',
		name: i18n.t('i18n.unlimited'),
		validator: '^\\d*\\.?\\d+$',
		warning: i18n.t('i18n.unlimitedWarning'),
		maxDecimal: Infinity,
	},
	{
		// TODO: what is 'sortable' - should all number not be sortable ?
		key: 'sortable',
		name: i18n.t('i18n.sortable'),
		validator: '.*',
		warning: '',
		maxDecimal: Infinity,
	},
];

// For the textTypes and numberTypes array, the array index is the value stored in the attribute spec field
// (spec1 for text, spec2 for number)
export let textTypes = [
	{
		name: 'None',
	},
	{
		name: 'Clear',
	},
];

export let typeLabels = {
	date: i18n.t('i18n.date'),
	hierarchical: i18n.t('i18n.hierarchical'),
	multiselect: i18n.t('i18n.multiSelectBox'),
	number: i18n.t('i18n.number'),
	select: i18n.t('i18n.pulldown'),
	semantic: i18n.t('i18n.semantic'),
	tag: i18n.t('i18n.tag'),
	text: i18n.t('i18n.text'),
	textarea: i18n.t('i18n.textarea'),
};

export let types = _.invert(ids);

export default {
	defaultAttributeColumns,
	editable,
	facetAttributeSupport,
	numberTypes,
	textTypes,
	types,
};
